import { DEFAULT_TIME_FORMAT } from "../../../constants/constants";
import { DateHelper, renderRecordValue } from "../../../utils";
import { renderPhoneNumber } from "../../../utils/helpers";

export const transformData = ({
  data,
  Navigation,
}) => {
  return data?.map((value) => {
    return {
      key: value.id,
      name:
        (value.firstName || value.lastName) &&
        renderRecordValue(`${value.firstName} ${value.lastName}`),
      dob: value?.dob,
      createdAt: value?.createdAt,
      phoneNumber: value.phoneNumber,
      statusMsg: value.statusMsg,
      isValid: value.isValidData,
      createdBy: value.createdByName,
    };
  });
};

export const renderColumns = (isMHAdmin, searchValue, highlighted) =>
  [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 150,
    },
    {
      title: "Date of Birth",
      dataIndex: "dob",
      key: "dob",
      render: (text) =>
        renderRecordValue(text && DateHelper.format(new Date(text), "MM/dd/Y")),
      width: 120,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      render: (text) => renderPhoneNumber(text),
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "isValid",
      key: "isValid",
      render: (text) => (text ? "Successful " : "Error Uploading"),
      width: 120,
    },
    {
      title: "Details",
      dataIndex: "statusMsg",
      key: "statusMsg",
      width: 220,
    },
  ].filter((col) => (isMHAdmin ? col : col.title !== "Health Organization"));


export const transformStatusTableData = (payload) => {
  if (payload?.importRiders?.length > 0) {
    const importRecord = payload?.importRiders[0];
    return [{
      key: importRecord.id,
      fileName: importRecord.fileName,
      createdBy: renderRecordValue(`${importRecord.createdBy.firstName} ${importRecord.createdBy.lastName} ${importRecord.createdBy.email}`),
      syncCount: payload.syncCount,
      failedCount: payload.failedCount,
      createdAt: DateHelper.format(new Date(importRecord.createdAt), DEFAULT_TIME_FORMAT)
    }];
  }

  return [{
    key: null,
    fileName: null,
    createdBy: null,
    syncCount: null,
    failedCount: null,
    createdAt: null
  }];
};

export const renderStatusColumn = () => [
  {
    title: "Name",
    dataIndex: "fileName",
    key: "fileName",
    width: 80,
  },
  {
    title: "New Records",
    dataIndex: "syncCount",
    key: "syncCount",
    width: 50,
  },
  {
    title: "Error Count",
    dataIndex: "failedCount",
    key: "failedCount",
    width: 50,
  },
  {
    title: "Source",
    key: "source",
    render: () => 'File',
    width: 50,
  },
  {
    title: "User",
    dataIndex: "createdBy",
    key: "createdBy",
    width: 120,
  },
  {
    title: "Created",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 80,
  }]
  ;
